<template>
  <main-layout :selectedMenu="'activity'">

    <div>
      <div class="banner">
      </div>
      <div class="content1">
        <div class="left">
          <div>即刻加入MANA{{$t('global.认证合作艺术家')}}，{{$t('global.上传作品')}}，立享三大优势：</div>
          <div>MANA 艺术平台，</div>
          <div>无风险版权诉讼，侵权必索赔</div>
          <div>面对侵权，官司是打还是不打？不打是任由自己的作品被肆意践踏，打就面临着花了数万法务费用依然拿不回赔偿的风险。
          </div>
          <div>即刻，加入认证合作艺术家，无需犹豫，必须打！</div>
          <div class="space"></div>
          <div>MANA和第三方合作，世界艺术馆，让世界看到你的设计</div>
          <div> 你的设计，10万贵还是不贵？你的才华远不止于这个价格，可市场却总把它低估。
          </div>
          <div>即刻，加入合作艺术家，让世界看到你设计的价值！</div>
          <div class="space"></div>
          <div>加入MANA,你就是登上国际舞台的摄影师</div>
          <div>
            拿了多年镜头，却没有什么可以吹牛逼的？你的作品堪称世界级，却没机会登上世界级舞台。即刻，加入MANA合作艺术家，有水平，必须秀！

          </div>

        </div>
        <div class="right">
        </div>
      </div>
      <div class="cooperate">
        <div class="header">{{$t('global.申请合作')}}</div>
        <div class="describe">填写以下表单，工作人员审核通过后，即可成为合作艺术家。带*{{$t('global.为必填内容')}}</div>
        <div class="contain">
          <div class="left">
            <div class="font">{{$t('global.真实姓名')}}*</div>
            <input type="text"
                   class="real-name"
                   v-model="realName">
          </div>
          <div class="right">
            <div class="font">{{$t('global.选择领域')}}*</div>
            <select v-model="field">
              <option v-for="(item ,index) in industryList"
                      :key="index"
                      :value="item.categoryId">{{item.title}}</option>
            </select>
            <!--<input type="text" class="choose">-->
          </div>
        </div>
        <div class="contain">
          <div class="left">
            <div class="font">{{$t('global.手机号码')}}*</div>
            <input type="text"
                   class="phone"
                   v-model="phone">
          </div>
          <div class="right">
            <div class="font">{{$t('global.常用邮箱')}}*</div>
            <input type="text"
                   class="email"
                   v-model="email">
          </div>
        </div>
        <div class="contain">
          <div class="left">
            <div class="font">{{$t('global.在线作品链接')}}（{{$t('global.可选')}}）</div>
            <input type="text"
                   class="resetW"
                   v-model="worksLink">
          </div>
        </div>
        <div class="up-load-wrap">
          <div class="font">{{$t('global.上传您的简历')}}*</div>
          <div class="upload button"
               @click="upFileClick">{{$t('global.上传简历')}}</div>
          <div class="right"><span ref="proWord">{{$t('global.文件正在上传')}}</span>
            <span ref="proNumber"></span>
          </div>
          <div class="progress">
            <div class="p-top"
                ref="progress"></div>
          </div>
        </div>
        <div class="submit button"
             @click="cooperationArtist">{{$t('global.提交审核')}}</div>
      </div>
      <service />
      <input type="file"
             class="upInput"
             @change="upFile">
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout"
import service from '../components/service.vue'

export default {
  name: 'identification',
  metaInfo() {
    return {
      title: this.$t("global.认证合作艺术家") + " | MANA"
    };
  },
  data() {
    return {
      realName: '',
      phone: '',
      email: '',
      worksLink: '',
      field: '',
      resume: '',
      industryList: []
    }
  },
  components: {
    service,
    MainLayout
  },
  created() {
    this.categoryList()
  },
  methods: {
    cooperationArtist() {
      this.$http
        .post('/api/artist/create', {
          realName: this.realName,
          phone: this.phone,
          email: this.email,
          worksLink: this.worksLink,
          field: this.field,
          resume: this.resume
        })
        .then(response => {
          this.$message({
            message: response.message,
            type: 'success'
          })
        })
    },
    upFileClick(index) {
      document.querySelector('.upInput').click()
    },
    upFile(e) {
      let param = new FormData() 
      param.append('files', e.target.files[0]) 
      this.$refs.proWord.innerHTML = this.$t('global.文件正在上传')
      let config = {
        loading: false,
        onUploadProgress: progressEvent => {
          var complete = (progressEvent.loaded / progressEvent.total * 100) | 0
          this.$refs.progress.style.width = complete + '%'
          this.$refs.proNumber.innerHTML = `${this.$t('global.已上传')}${complete}%`
        },
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.$http
        .post('/api/common/upload/file', param, config)
        .then(response => {
          this.$message({
            message: response.message,
            type: 'success'
          })
          this.resume = response.data
          this.$refs.proNumber.innerHTML = ''
          this.$refs.proWord.innerHTML = this.$t('global.文件上传成功')
        })
    },
    categoryList() {
      this.$http.get('/api/common/categoryList').then(response => {
        this.industryList = response.data.industryList
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.upInput
  display none
.banner-mask
  background rgba(0, 0, 0, 0.5)
  width 100%
  height 5.9rem
  color #ffffff
  font-size 0.36rem
  display flex
  justify-content center
  flex-direction column
  align-items center
.submit
  margin 0.4rem auto
.up-load-wrap
  margin-top 0.4rem
  .right
    float right
    width 6rem
    font-size 0.16rem
    text-align right
    color #707070
    margin-top -.1rem
    span
      display inline-block
      margin-left 0.3rem
  .progress
    margin-top 0.26rem
    position relative
    height 10px
    background-color #f9f9f9
    border-radius 0.05rem
    .p-top
      position absolute
      left 0
      top 0
      width 0
      height 10px
      background-color #0161ff
      border-radius 0.05rem
.button
  width 2.4rem
  height 0.64rem
  line-height 0.6rem
  text-align center
  font-size 0.2rem
  color #FFFFFF
  background rgba(1, 97, 255, 1)
  border-radius 0.08rem
  margin-top 0.2rem
.contain
  display flex
  justify-content space-between
  margin-top 0.4rem
  input, select
    width 6rem
    height 0.5rem
    margin-top 0.1rem
    background-color #F9F9F9
    border-radius 0.08rem
    text-indent 0.1rem
    outline none
    border none
  .resetW
    width 14.79rem
.cooperate
  width 14.8rem
  height 7rem
  background-color #ffffff
  padding 0.6rem
  margin 0.2rem auto 0
  text-align left
  .header
    font-size 0.3rem
    line-height 0.38rem
    font-weight bold
    color #333333
    text-indent 0
  .describe
    font-size 0.14rem
    color #707070
    line-height 0.24rem
.banner
  width 100%
  height 6rem
  background url('/static/identification/Header05.png') no-repeat
  background-size 100%
.content1
  width 14.8rem
  height 3rem
  margin 0.4rem auto 0
  display flex
  padding 0.6rem
  justify-content space-between
  background-color #ffffff
  .left
    flex 1
    margin 0 1.26rem 0 0
    line-height 0.25rem
    font-size 0.16rem
  .space
    width 100%
    height 0.12rem
  .right
    width 4.86rem
    height 3.06rem
    align-self center
    background url('/static/identification/right.png') no-repeat
    background-size 100%
</style>




// WEBPACK FOOTER //
// src/pages/identification.vue